import React, { ChangeEvent, FC, FormEvent, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import Alert from "../../components/Alert";
import AuthCard from "../../layouts/AuthCard";
import ButtonPrimary from "../../components/ButtonPrimary";
import FormGroup from "../../components/FormGroup";
import Label from "../../components/Label";
import Input from "../../components/Input";
import Link from "../../components/Link";
import authPasswordAPIService from "../../services/api/auth";
import { getLabelTranslation } from "./utils";
import { selectBrandCode } from "../../store/metadata";
import { useUserManager } from "../../services/auth";

import "./styles.scss";

export const ResetPassword: FC = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [username, setUsername] = useState("");
  const [isValid, setIsValid] = useState(false);
  const brandCode = useSelector(selectBrandCode);
  const formRef = useRef<HTMLFormElement>(null);
  const { t } = useTranslation();
  const label = t(getLabelTranslation(brandCode));
  const userManager = useUserManager();

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();

    setIsSuccess(false);

    try {
      await authPasswordAPIService.resetPassword({ username });
    } finally {
      setIsSuccess(true);
    }
  };

  const createInputChangeEventHandler = (setValue: (value: any) => void) => {
    return (event: ChangeEvent<HTMLInputElement>) => {
      setIsValid(formRef.current?.checkValidity() || false);
      setValue(event.target.value);
    };
  };

  const goToLoginPage = async () => {
    userManager.signinRedirect();
  };

  return (
    <AuthCard>
      <form
        className="ams-reset-password-form"
        id="reset-password-form"
        ref={formRef}
        onSubmit={handleSubmit}
      >
        <h1 className="ams-reset-password-form__title">{t("resetPassword")}</h1>
        {isSuccess && (
          <Alert variant="success" id="success-alert">
            {t("resetPasswordSuccess")}
          </Alert>
        )}
        <FormGroup>
          <Label>{label}</Label>
          <Input
            id="username-input"
            value={username}
            onChange={createInputChangeEventHandler(setUsername)}
            required
          />
        </FormGroup>
        <div className="ams-reset-password-form__actions flex flex-column">
          <ButtonPrimary
            className="ams-reset-password-form__action"
            type="submit"
            size="large"
            disabled={!isValid}
          >
            {t("resetPassword")}
          </ButtonPrimary>
        </div>

        <Link data-el-id={"login-link"} onClick={goToLoginPage}>
          {t("login")}
        </Link>
      </form>
    </AuthCard>
  );
};
